import { IdentifierDTO } from '@zazume/zzm-base';

import { PaginationOptions } from '#/hooks';
import { AffiliateOffer } from '#/models/rewards/AffiliateOffer';

import { doGet, doPost, doPut, doDelete, doPostFileUpload, toPaginatedURL } from '../../helpers';

interface AffiliateOffersFilters {
  categories?: string;
}

export const affiliateOffers = {
  getAll: (pagination: PaginationOptions, filters?: AffiliateOffersFilters) => () => {
    const url = toPaginatedURL('/affiliate-offers', pagination);
    if (filters?.categories) {
      const separator = url.includes('?') ? '&' : '?';
      return doGet<AffiliateOffer[]>(`${url}${separator}categories=${filters.categories}`);
    }
    return doGet<AffiliateOffer[]>(url);
  },
  get: (offerId: IdentifierDTO) => () => doGet(`/affiliate-offers/${offerId}`),
  create:
    () =>
    (data: any): Promise<IdentifierDTO> =>
      doPost('/affiliate-offers', data),
  update: (offerId: IdentifierDTO) => (data: any) => doPut(`/affiliate-offers/${offerId}`, data),
  delete: () => (offerId: IdentifierDTO) => doDelete(`/affiliate-offers/${offerId}`),
  reorder: () => (data: { _id: IdentifierDTO; order: number }) =>
    doPut(`/affiliate-offers/${data._id}/reorder`, { order: data.order }),
  uploadLogo: (offerId: IdentifierDTO) => (formData: FormData) =>
    doPostFileUpload(`/affiliate-offers/${offerId}/logo`, formData),
  uploadImage: (offerId: IdentifierDTO) => (formData: FormData) =>
    doPostFileUpload(`/affiliate-offers/${offerId}/image`, formData)
};
